import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Popup } from "devextreme-react/popup";
import { LoadPanel } from "devextreme-react/load-panel";
import {
    DataGrid,
    Column,
    Scrolling,
    FilterRow,
    LoadPanel as GridLoadPanel,
} from "devextreme-react/data-grid";
import axios from "axios";

const currencyFormat = {
    type: "currency",
    precision: 2,
    currency: "USD",
    useGrouping: true,
};

function CustomerHistoryPopup(props) {
    const { showPopup = {}, setShowPopup, oidc } = props;
    const visible = showPopup.visible === true;
    const accessToken = oidc?.user?.access_token;

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!visible) return;
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            try {
                const res = await axios.get(
                    `${window._env_.REACT_APP_APIS}/om/SalesOrderHeaderOperations/GetCustomerOrderHistory`,
                    {
                        params: {
                            RTransactionHeader: showPopup.headerRowId,
                            RCustomer: showPopup.customerId,
                        },
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                if (!cancelled) setRows(Array.isArray(res.data) ? res.data : []);
            } catch {
                if (!cancelled) setRows([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [visible, showPopup.headerRowId, showPopup.customerId, accessToken]);

    const handleHiding = () => {
        setShowPopup((prev) => ({ ...prev, visible: false }));
    };

    if (!visible) return null;

    return (
        <Popup
            visible={true}
            onHiding={handleHiding}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title={showPopup.title ?? "Customer Order History"}
            width="90vw"
            height="90vh"
        >
            <div ref={rootRef} style={{ height: "100%", position: "relative" }}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    container={rootRef.current ?? undefined}
                    position={rootRef.current ? { my: "center", at: "center", of: rootRef.current } : undefined}
                    visible={loading}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <DataGrid
                    dataSource={rows}
                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    hoverStateEnabled={true}
                    height="100%"
                    showColumnLines={true}
                    showRowLines={true}
                    paging={false}
                >
                    <Scrolling mode="standard" />
                    <GridLoadPanel enabled={false} />
                    <FilterRow visible={true} />
                    <Column dataField="TransactionNumber" caption="Transaction #" dataType="string" />
                    <Column dataField="TransactionType" caption="Type" dataType="string" />
                    <Column dataField="TransactionDate" caption="Order" dataType="date" format="shortDate" />
                    <Column dataField="BO" caption="B.O." dataType="string" />
                    <Column dataField="TransactionSubType" caption="Sub-Type" dataType="string" />
                    <Column dataField="InvoiceDate" caption="Invoice" dataType="date" format="shortDate" />
                    <Column dataField="ShippingDate" caption="Ship" dataType="date" format="shortDate" />
                    <Column dataField="PurchaseOrderNumber" caption="PO Number" dataType="string" />
                    <Column dataField="Reference" caption="Reference #" dataType="string" />
                    <Column dataField="Amount" caption="Amt" dataType="number" alignment="right" format={currencyFormat} />
                    <Column dataField="Currency" caption="Currency" dataType="string" alignment="right" />
                    <Column dataField="TotalForeignAmount" caption="Foreign Amt" dataType="number" alignment="right" format={currencyFormat} />
                </DataGrid>
            </div>
        </Popup>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CustomerHistoryPopup);
